import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StringConstants from '../../constants/StringConstants';
import NavigateToWebApps from '../../utils/NavigateToWebApps';
import envConfig from '../../../static/config';
import InternetBankingActions from '../../actions/InternetBankingActions';
import UserManagementStore from '../../stores/UserManagementStore';
import AccountsStore from '../../stores/AccountsStore';
import { saveNavigationReference } from '../../actions/PaymentStatusActionCreator';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import SvgIcon from '../common/SvgIcon';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import { isVMBusiness } from '../../utils/BrandUtils';
import { shouldShowDocumentLib } from '../homepage/HomepageTilesUtils';

const getLinkItem = (handleClick, linkText) => (
  <li className="c-panel__item">
    <button className="c-panel__sblink" onClick={handleClick}>
      {linkText}
    </button>
  </li>
);

class QuickLinksTile extends Component {
  constructor(props) {
    super(props);
    this.handlePaymentStatusClick = this.handlePaymentStatusClick.bind(this);
    this.handleMobileAccessClick = this.handleMobileAccessClick.bind(this);
    this.handleUserManagementClick = this.handleUserManagementClick.bind(this);
    this.handleDocumentLibClick = this.handleDocumentLibClick.bind(this);
    this.handleManageYourPayeeClick =
      this.handleManageYourPayeeClick.bind(this);
  }

  handleMobileAccessClick() {
    NavigateToWebApps.navigateTo(envConfig.deviceManagementLink);
  }

  handlePaymentStatusClick() {
    saveNavigationReference('WEB-HOMEPAGE');
    InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT-STATUS');
  }

  handleUserManagementClick() {
    NavigateToWebApps.navigateTo(envConfig.userManagementLink);
  }

  handleManageYourPayeeClick() {
    MoveMoneyActionCreator.saveNavigationReference('WEB-HOMEPAGE');
    MoveMoneyStore.setDisplayManagePayeePage(true);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
  }

  handleDocumentLibClick() {
    saveNavigationReference('WEB-HOMEPAGE');
    InternetBankingActions.navigateToWebTask('WEB-DOCUMENT-LIBRARY');
  }

  render() {
    const listItemsWithIcons = [];
    if (AccountsStore.getTotalNumberOfAccounts() > 0) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handlePaymentStatusClick,
          StringConstants.paymentStatusQuickLink
        )
      );
    }
    if (
      envConfig.isDeviceManagementEnabled &&
      UserManagementStore.isManageDeviceEnabled() &&
      !UserManagementStore.isNominatedUser()
    ) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleMobileAccessClick,
          StringConstants.mobileDeviceAccessQuickLink
        )
      );
    }
    if (
      envConfig.isUserManagementEnabled &&
      UserManagementStore.isUserReadEnabled()
    ) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleUserManagementClick,
          StringConstants.userManagementQuickLink
        )
      );
    }
    if (AccountsStore.getManagePayeesFlag()) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleManageYourPayeeClick,
          StringConstants.manageYourPayeeQuickLink
        )
      );
    }
    if (shouldShowDocumentLib()) {
      listItemsWithIcons.push(
        getLinkItem(
          this.handleDocumentLibClick,
          StringConstants.DocumentLibQuickLink
        )
      );
    }
    if (listItemsWithIcons.length) {
      return (
        <div
          id="site-sidebar"
          tabIndex="-1"
          className="c-panel l-tile c-quicklink-tile"
        >
          <div className="c-panel-info">
            <h3 className="c-panel__heading">
              {!isVMBusiness() && (
                <span className="c-panel__icons">
                  <SvgIcon id="icon-quickLinks" width="16px" height="16px" />
                </span>
              )}
              {StringConstants.quickLinkTitle}
            </h3>
            <div className="c-panel__body">
              <ul className="c-panel__list">{listItemsWithIcons}</ul>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

QuickLinksTile.propTypes = {
  data: PropTypes.string,
  content: PropTypes.shape({}),
};
export default QuickLinksTile;
